import { useEffect } from "react";
import { BRAND_NAME } from "@/lib/constants";

export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} — ${BRAND_NAME}`;
  }, [title]);
}
